import { render, staticRenderFns } from "./PreviewMessageEvaluate.vue?vue&type=template&id=0654cd64"
import script from "./PreviewMessageEvaluate.vue?vue&type=script&lang=js"
export * from "./PreviewMessageEvaluate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports